import script from "./AdminOffersList.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminOffersList.vue?vue&type=script&setup=true&lang=js"

import "./AdminOffersList.vue?vue&type=style&index=0&id=36373d43&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36373d43"]])

export default __exports__